import { ActionIcon, Box, Group } from '@mantine/core';

import { IconX } from '@tabler/icons-react';

import { IconTileView } from '../../atoms/IconTile';
import type { DetailDrawerHeaderViewProps } from './DetailDrawerHeader.types';

export function DetailDrawerHeaderView({
  icon,
  iconColor = 'brand',
  title,
  menu,
  onClose,
}: DetailDrawerHeaderViewProps) {
  return (
    <Group
      justify="space-between"
      wrap="nowrap"
      gap="sm"
      p="md"
      style={{ borderBottom: '1px solid var(--mantine-color-gray-3)', flexShrink: 0 }}
    >
      <Group gap="sm" wrap="nowrap" style={{ minWidth: 0, flex: 1 }}>
        {icon && <IconTileView icon={icon} color={iconColor} />}
        <Box style={{ minWidth: 0, flex: 1 }}>{title}</Box>
      </Group>
      <Group gap={4} wrap="nowrap" style={{ flexShrink: 0 }}>
        {menu}
        <ActionIcon variant="subtle" color="gray" onClick={onClose}>
          <IconX size={16} />
        </ActionIcon>
      </Group>
    </Group>
  );
}
